import { graphql } from '~/lib/graphql'

export const PlanCancelPolicy = graphql(`
  fragment PlanCancelPolicy on Plan {
    cancelPolicy: cancelPolicy3 {
      __typename
      ... on CancelPolicyStructured {
        cancelPolicyId
        version
        note
        ...CancelPolicyPolicies
      }
      ... on CancelPolicyText {
        text
      }
    }
  }
`)
